
import classNames from 'classnames'

import styles from './button.module.sass'

import BlockWrapper from '../layout/block_wrapper'
import ScrollAnimation from '../layout/scroll_animation'

function renderButton(props){
	const fields = props.fields?.button

	let button_style = props.button_style || props.fields?.button_style || 'style_1'
	// let appearance = props.appearance || 'standard'
	let color = props.color !== 'default' && props.color|| props.fields?.button_color != 'default' && props.fields?.button_color || 'green'
	let size = props.size || ''
	let active = props.active || false
	let classes = null

	if(active){
		classes += ' ' + styles.active
	}
	
	if(fields){
		return <a href={fields.url} target={fields.target} className={classNames(styles[button_style], styles[color], styles[size], classes)}>{fields.title}</a>
	} else {
		return <span className={classNames(styles[button_style], styles[color], styles[size], classes)}>{props.children}</span>
	}
}

function Button(props) {

	if(props.layout_settings){
		return <BlockWrapper {...props} fullbleed={props.accordionContent ? false : true} className={styles.button}>
				<ScrollAnimation styles={styles}>
					{renderButton(props)}
				</ScrollAnimation>
			</BlockWrapper>
	} else {
		return <div className={classNames(styles.button, props.className)}>
				{renderButton(props)}
			</div>
	}
}

export default Button